"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DL = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dl = require("./dl.states");

var _index = require("../../svg/index");

var _Loading = require("../Loading/Loading");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _variables = require("../../styles/variables");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["items", "defaultItem", "label", "helper", "err", "searchable", "toggleItem", "size", "loading", "disabled"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var heightSize = function heightSize(size) {
  switch (size) {
    case "xs":
      return "38px";

    case "sm":
      return "48px";

    case "lg":
      return "60px";

    default:
      return "48px";
    //sm
  }
};

var textFontSize = function textFontSize(size) {
  switch (size) {
    case "xs":
      return "12px";

    case "sm":
      return "16px";

    case "lg":
      return "18px";

    default:
      return "16px";
    //sm
  }
};

var messageFontSize = function messageFontSize(size) {
  switch (size) {
    case "xs":
    case "sm":
      return "12px";

    case "lg":
      return "14px";

    default:
      return "12px";
    //sm
  }
};

var StyledDropdownWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var Title = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), _variables.colors.night);

var Angle = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transform: ", ";\n  transition: 0.3s ease all;\n"])), function (_ref) {
  var flag = _ref.flag;
  return "rotate(".concat(flag ? "90deg" : "180deg", ")");
});

var labelSizes = {
  lg: "14px",
  sm: "12px",
  xs: "12px"
};

var StyledLabel = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  position: ", ";\n  visibility: visible;\n  line-height: 3px;\n  top: ", ";\n  right: ", ";\n  padding: ", ";\n  font-size: ", ";\n  transition: 0.2s ease all;\n  color: ", ";\n"])), _variables.colors.ghost, function (_ref2) {
  var selected = _ref2.selected;
  return selected ? "absolute" : "unset";
}, function (_ref3) {
  var selected = _ref3.selected;
  return selected ? "0px" : "unset";
}, function (_ref4) {
  var selected = _ref4.selected;
  return selected ? "10px" : "unset";
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected ? "0px 5px" : "unset";
}, function (_ref6) {
  var selected = _ref6.selected,
      size = _ref6.size;
  return selected ? labelSizes[size] : "unset";
}, _variables.colors.wolf);

var StyledDropdownHeader = _styledComponents["default"].button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: IranSansX, sans-serif;\n  font-size: ", ";\n  color: ", ";\n  width: 100%;\n  height: ", ";\n  border: ", ";\n  border-radius: 10px;\n  padding: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  direction: rtl;\n  cursor: pointer;\n  background-color: ", ";\n  &:disabled {\n    background-color: ", ";\n    cursor: default;\n  }\n  &:disabled ", " {\n    svg {\n      g {\n        path {\n          fill: ", ";\n        }\n      }\n    }\n  }\n  &:disabled ", " {\n    color: ", ";\n  }\n"])), function (_ref7) {
  var size = _ref7.size;
  return textFontSize(size);
}, _variables.colors.night, function (_ref8) {
  var size = _ref8.size;
  return heightSize(size);
}, function (_ref9) {
  var err = _ref9.err;
  return "1px solid ".concat(err ? _variables.colors.fire : _variables.colors.hare);
}, function (_ref10) {
  var size = _ref10.size;
  return size === "xs" ? "18px 16px" : "23px 16px";
}, _variables.colors.ghost, _variables.colors.swan, Angle, _variables.colors.whale, Title, _variables.colors.whale);

var StyledDropdownList = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: IranSansX, sans-serif;\n  font-size: ", ";\n  color: ", ";\n  margin-top: 10px;\n  position: absolute;\n  z-index: 20;\n"])), function (_ref11) {
  var size = _ref11.size;
  return textFontSize(size);
}, _variables.colors.night);

var StyledDropdownError = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  direction: rtl;\n  font-family: IranSansX, sans-serif;\n  margin: ", ";\n"])), _variables.colors.fire, function (_ref12) {
  var size = _ref12.size;
  return messageFontSize(size);
}, function (_ref13) {
  var size = _ref13.size;
  return size === "xs" ? "4px 16px 0 0" : size === "sm" ? "4px 16px 0 0" : "10px 16px 0 0";
});

var StyledDropdownHelper = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  direction: rtl;\n  font-family: IranSansX, sans-serif;\n  margin: ", ";\n"])), _variables.colors.wolf, function (_ref14) {
  var size = _ref14.size;
  return messageFontSize(size);
}, function (_ref15) {
  var size = _ref15.size;
  return size === "xs" ? "4px 16px 0 0" : size === "sm" ? "4px 16px 0 0" : "10px 16px 0 0";
});

var StyledSearchBox = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: relative;\n"])));

var StyledScrollList = _styledComponents["default"].div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  border-top: ", ";\n  border: 1px solid ", ";\n  direction: rtl;\n  max-height: ", ";\n  overflow: auto;\n"])), function (_ref16) {
  var searchable = _ref16.searchable;
  return searchable ? "0 0 10px 10px" : "10px";
}, function (_ref17) {
  var searchable = _ref17.searchable;
  return searchable ? "unset" : " 1px solid ".concat(_variables.colors.hare);
}, _variables.colors.hare, function (_ref18) {
  var size = _ref18.size;
  return size === "xs" ? "35vh" : "50vh";
});

var StyledSearchIcon = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 30%;\n  right: 20px;\n  & svg {\n    width: ", ";\n    height: ", ";\n  }\n"])), function (_ref19) {
  var size = _ref19.size;
  return size === "xs" ? "15px" : "unset";
}, function (_ref20) {
  var size = _ref20.size;
  return size === "xs" ? "15px" : "unset";
});

var StyledLoading = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  backdrop-filter: blur(6px);\n  background-color: rgba(0, 0, 0, 0.6);\n  border-radius: 10px;\n"])), function (_ref21) {
  var size = _ref21.size;
  return heightSize(size);
});

var StyledSearchBar = _styledComponents["default"].input(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: IranSansX, sans-serif;\n  font-size: 14px;\n  height: ", ";\n  color: ", ";\n  background-color: ", ";\n  border-radius: 10px 10px 0 0;\n  border: none;\n  direction: rtl;\n  text-indent: 60px;\n"])), function (_ref22) {
  var size = _ref22.size;
  return heightSize(size);
}, _variables.colors.wolf, _variables.colors.swan);

var StyledDropdownListItem = _styledComponents["default"].button(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: ", ";\n  font-family: IranSansX, sans-serif;\n  font-size: ", ";\n  color: ", ";\n  padding: ", ";\n  display: flex;\n  direction: rtl;\n  cursor: pointer;\n  background-color: ", ";\n  border: none;\n  align-items: center;\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_ref23) {
  var size = _ref23.size;
  return heightSize(size);
}, function (_ref24) {
  var size = _ref24.size;
  return textFontSize(size);
}, _variables.colors.night, function (_ref25) {
  var size = _ref25.size;
  return size === "xs" ? "18px 16px" : "23px 16px";
}, _variables.colors.ghost, _variables.colors.swan);

var DL = /*#__PURE__*/(0, _react.forwardRef)(function (_ref26, ref) {
  var _selected$title;

  var items = _ref26.items,
      defaultItem = _ref26.defaultItem,
      label = _ref26.label,
      helper = _ref26.helper,
      err = _ref26.err,
      searchable = _ref26.searchable,
      toggleItem = _ref26.toggleItem,
      size = _ref26.size,
      loading = _ref26.loading,
      disabled = _ref26.disabled,
      htmlAttributes = _objectWithoutProperties(_ref26, _excluded);

  var listItemsRef = (0, _react.useRef)();
  var wrapperRef = (0, _react.useRef)();

  var _useFlag = (0, _dl.useFlag)(false),
      _useFlag2 = _slicedToArray(_useFlag, 2),
      flag = _useFlag2[0],
      dispatchFlag = _useFlag2[1];

  var _useFlag3 = (0, _dl.useFlag)(defaultItem),
      _useFlag4 = _slicedToArray(_useFlag3, 2),
      selected = _useFlag4[0],
      doFetchSelect = _useFlag4[1];

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      selected: selected,
      doFetchSelect: doFetchSelect
    };
  }, [selected]);

  function picked(obj) {
    toggleItem(obj);
    doFetchSelect(obj);
    dispatchFlag(!flag);
  }

  function listItems() {
    return items.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(StyledDropdownListItem, {
        key: index,
        size: size,
        type: "button",
        onClick: function onClick() {
          return picked(item);
        },
        role: "option"
      }, item.title);
    });
  }

  function toggleList() {
    dispatchFlag(!flag);
  }

  function filterFunction(v) {
    var _iterator = _createForOfIteratorHelper(listItemsRef.current.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        var txtContent = value.textContent;

        if (txtContent.indexOf(v) > -1) {
          value.style.display = "";
        } else {
          value.style.display = "none";
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  (0, _react.useEffect)(function () {
    if (defaultItem) {
      doFetchSelect(defaultItem);
      toggleItem(defaultItem);
    }

    if (defaultItem === "") {
      doFetchSelect(defaultItem);
      toggleItem(defaultItem);
    }
  }, [defaultItem]);
  (0, _react.useEffect)(function () {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        dispatchFlag(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  return /*#__PURE__*/_react["default"].createElement(StyledDropdownWrapper, _extends({
    ref: wrapperRef
  }, htmlAttributes), /*#__PURE__*/_react["default"].createElement(StyledDropdownHeader, {
    type: "button",
    onClick: function onClick() {
      return toggleList();
    },
    disabled: disabled,
    size: size,
    err: err
  }, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    size: size,
    selected: selected
  }, label), /*#__PURE__*/_react["default"].createElement(Title, null, (_selected$title = selected === null || selected === void 0 ? void 0 : selected.title) !== null && _selected$title !== void 0 ? _selected$title : null), /*#__PURE__*/_react["default"].createElement(Angle, {
    flag: flag
  }, _index.arrow)), flag && /*#__PURE__*/_react["default"].createElement(StyledDropdownList, {
    size: size,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, searchable.length > 0 && /*#__PURE__*/_react["default"].createElement(StyledSearchBox, null, /*#__PURE__*/_react["default"].createElement(StyledSearchBar, {
    placeholder: searchable[0],
    onChange: function onChange(e) {
      return filterFunction(e.target.value);
    },
    autoFocus: true
  }), /*#__PURE__*/_react["default"].createElement(StyledSearchIcon, {
    size: size
  }, _index.searchIcon)), loading ? /*#__PURE__*/_react["default"].createElement(StyledLoading, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(_Loading.Loading, null)) : /*#__PURE__*/_react["default"].createElement(StyledScrollList, {
    ref: listItemsRef,
    searchable: searchable,
    size: size
  }, listItems())), helper && /*#__PURE__*/_react["default"].createElement(StyledDropdownHelper, {
    size: size
  }, helper), err && /*#__PURE__*/_react["default"].createElement(StyledDropdownError, {
    size: size
  }, err));
});
exports.DL = DL;
DL.propTypes = {
  /** An array of items for show in the list */
  items: _propTypes["default"].array,

  /** An array of items for show default selected */
  defaultItem: _propTypes["default"].object,

  /** Drop list label */
  label: _propTypes["default"].string,

  /** Help text, Is displayed below the list */
  helper: _propTypes["default"].string,

  /** Error text , Is displayed below the list and change border color */
  err: _propTypes["default"].string,

  /** Flag for show filter input */
  searchable: _propTypes["default"].array,

  /** Get selected items from component */
  toggleItem: _propTypes["default"].func,

  /** Change component size */
  size: _propTypes["default"].oneOf(["xs", "sm", "lg"]),

  /** Show loading */
  loading: _propTypes["default"].bool,

  /** disable list */
  disabled: _propTypes["default"].bool
};
DL.defaultProps = {
  items: [],
  defaultItem: undefined,
  label: "\u0627\u0646\u062A\u062E\u0627\u0628 \u06A9\u0646\u06CC\u062F",
  helper: "",
  err: "",
  searchable: [],
  toggleItem: function toggleItem() {},
  size: "sm",
  loading: false,
  disabled: false
};